import { type AxiosResponse } from 'axios';

import { ordersAPI } from '~/services/api';
import { WEB_ORDERS_API } from '~/services/web-orders.service';

import {
  type UpdateOrdersTags,
  type UpdateOrdersTagsParams,
  type UpdateOrdersTagsResponseBody,
} from './update-orders-tags.service.types';

/**
 * Updates the tags of multiple orders, the tags are appended to the orders existing tags.
 *
 * @param order_ids - The IDs of the orders to update.
 * @param tag_ids - The IDs of the tags to assign to the orders.
 * @return {Promise<AxiosResponse<UpdateOrdersTagsResponseBody>>} Promise resolving to the updated orders.
 */
export const updateOrdersTags: UpdateOrdersTags = ({
  order_ids,
  tag_ids,
}: UpdateOrdersTagsParams): Promise<AxiosResponse<UpdateOrdersTagsResponseBody>> =>
  ordersAPI.request({
    data: {
      order_ids,
      tag_ids,
    },
    method: 'POST',
    url: `${WEB_ORDERS_API}/tags`,
  });
